// extracted by mini-css-extract-plugin
export default {"promosContainer":"Promos_promosContainer__jE6xG","promosSection":"Promos_promosSection__WCj4g","promosImg":"Promos_promosImg__VTUuO"};